import { useAuthStore } from '@/stores/auth'
import { hasPermission } from '@/utils/permissions'

export function can(path: string): boolean {
  return hasPermission(useAuthStore().user?.scope ?? [], path)
}

export function usePermissions(): { can: typeof can } {
  return { can }
}
